/* 요금제 단일 출처. 랜딩 요약 카드와 플랜 페이지 비교표가 같이 참조한다. */

export type Plan = {
  name: string
  price: string
  unit?: string
  desc: string
  items: string[]
  cta: string
  best?: boolean
  /** 있으면 가격 아래에 안내 뱃지가 붙는다 */
  note?: string
}

export const PLANS: Plan[] = [
  {
    name: 'Free',
    price: '무료',
    desc: '혼자 시작하는 1인 사업자를 위한 플랜',
    items: ['AI 에이전트 2개', '월 100건 자동화', '기본 매출·고객 리포트', '이메일 문의 지원'],
    cta: '무료로 시작하기',
  },
  {
    name: 'Trial',
    price: '1개월 체험판',
    desc: '유료 기능을 한 달 동안 그대로 써보는 플랜',
    items: [
      'AI 에이전트 전체 이용',
      '월 1,000건 자동화',
      '실시간 데이터 분석 대시보드',
      '광고·마케팅 성과 리포트',
      '채팅 지원',
    ],
    cta: '1개월 체험 시작하기',
    note: '카드 등록 없이 · 1개월 후 자동 종료',
  },
  {
    name: 'Standard',
    price: '₩5,900',
    unit: '/ 월',
    desc: '자동화를 본격적으로 쓰기 시작하는 단계',
    items: [
      'AI 에이전트 5개',
      '월 1,000건 자동화',
      '실시간 데이터 분석 대시보드',
      '광고·마케팅 성과 리포트',
      '채팅 지원',
    ],
    cta: 'Standard 시작하기',
    best: true,
  },
  {
    name: 'Pro',
    price: '₩29,000',
    unit: '/ 월',
    desc: '매출 규모가 커진 사업자를 위한 플랜',
    items: [
      'AI 에이전트 전체 이용',
      '자동화 건수 무제한',
      '맞춤 에이전트 설계',
      '기존 시스템 API 연동',
      '우선 지원',
    ],
    cta: 'Pro 시작하기',
  },
]

/** 비교표 한 줄. v는 [Free, Trial, Standard, Pro] 순서.
 *  true/false면 체크·빗금 아이콘, 문자열이면 그대로 출력. */
export type Row = { label: string; note?: string; v: (string | boolean)[] }
export type Group = { title: string; rows: Row[] }

export const COMPARE: Group[] = [
  {
    title: '이용 조건',
    rows: [
      { label: '이용 기간', v: ['무제한', '1개월', '무제한', '무제한'] },
      { label: '카드 등록', note: '시작할 때 결제 수단 필요 여부', v: ['불필요', '불필요', '필요', '필요'] },
      { label: '월 요금', v: ['무료', '무료', '₩5,900', '₩29,000'] },
    ],
  },
  {
    title: 'AI 에이전트',
    rows: [
      { label: '사용 가능 에이전트', v: ['2개', '전체', '5개', '전체'] },
      { label: '월 자동화 실행 건수', v: ['100건', '1,000건', '1,000건', '무제한'] },
      { label: '에이전트 동시 실행', v: ['1개', '3개', '3개', '무제한'] },
      { label: '맞춤 에이전트 설계', note: '업무에 맞춰 직접 구성', v: [false, false, false, true] },
    ],
  },
  {
    title: '데이터 · 리포트',
    rows: [
      { label: '매출·고객 기본 리포트', v: [true, true, true, true] },
      { label: '실시간 분석 대시보드', v: [false, true, true, true] },
      { label: '광고·마케팅 성과 리포트', v: [false, true, true, true] },
      { label: '데이터 보관 기간', v: ['3개월', '1개월', '12개월', '무제한'] },
      { label: '리포트 내려받기', v: ['PDF', 'PDF · CSV', 'PDF · CSV', 'PDF · CSV · API'] },
    ],
  },
  {
    title: '연동 · 운영',
    rows: [
      { label: '기존 시스템 API 연동', v: [false, false, false, true] },
      { label: '팀 계정', v: ['1명', '1명', '3명', '10명'] },
      { label: '접근 권한 관리', v: [false, false, false, true] },
    ],
  },
  {
    title: '지원',
    rows: [
      { label: '이메일 문의', v: [true, true, true, true] },
      { label: '채팅 지원', v: [false, true, true, true] },
      { label: '우선 지원', note: '영업일 기준 4시간 내 1차 응답', v: [false, false, false, true] },
    ],
  },
]
